import React from 'react';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow';
import ClientInvoiceService from '../../../Services/ClientInvoiceService';
import ApplyPaymentItem from '../../../Domain/ApplyPaymentItem';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import ErrorMessage from '../../../Elements/ErrorMessage';
import ClientPaymentService from '../../../Services/ClientPaymentService';
import OutstandingInvoiceItem from '../../../Domain/OutstandingInvoiceItem';
import ClientPaymentClientInvoiceSearchParams from './ClientPaymentClientInvoiceSearchParams';

export default class OutstandingClientInvoiceAdmin extends React.Component {
  static defaultProps = {
    clientPaymentId: 0,
  };

  constructor(props) {
    super(props);

    this.state = {
      allItemsInTheSearchSetAreSelected: false,
      itemList: [],
      numberOfElementsInTheTable: 0,
      selectedItem: {},
      searchItem: new ClientPaymentClientInvoiceSearchParams(props.clientPaymentId, 'outstanding'),
    };

    this.refresh = this.refresh.bind(this);
    this.applyPaymentFunction = this.applyPaymentFunction.bind(this);
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem } });
  }

  applyPaymentFunction() {
    const selectedItem = new ApplyPaymentItem();
    selectedItem.AllItemsInTheSearchAreSelected = this.state.allItemsInTheSearchSetAreSelected;
    selectedItem.NumberOfItemsSelected = this.state.allItemsInTheSearchSetAreSelected
      ? this.state.numberOfElementsInTheTable
      : this.state.itemList.filter((x) => x.Selected === true).length;
    selectedItem.ClientPaymentId = this.props.clientPaymentId;
    selectedItem.ClientInvoiceIds = this.state.itemList.filter((x) => x.Selected === true).map((x) => x.CiId);
    selectedItem.InvoiceType = 'outstanding';

    ClientPaymentService.ApplyPayment(selectedItem)
      .then((result) => {
        if (result && result.error) {
          ErrorMessage.SetErrorMessage(result.error);
        } else {
          ErrorMessage.SetNotification('Payment applied from Invoice(s).');
        }
        ErrorMessage.SetLoading(false);
        this.refresh();
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('OCIA55', error);
        ErrorMessage.SetLoading(false);
      });
    ErrorMessage.SetLoading(true);
  }

  getNumberOfSelectedElements() {
    return this.state.itemList.filter((x) => x.Selected === true).length;
  }

  renderButtons() {
    return (
      <div>
        <FigmaButtonRow
          buttons={[
            {
              type: ButtonTypeEnum.NormalNormal,
              color: ButtonColorsEnum.Common,
              onClick: () => ErrorMessage.SetApprove(this.getApproveMessage(), this.applyPaymentFunction),
              label: 'Apply Payment(s)',
              tooltip: 'Apply Payment(s)',
              roleKey: 'clientpayment_apply',
              disabled: this.getNumberOfSelectedElements() === 0,
            },
          ]}
        />
      </div>
    );
  }

  getApproveMessage() {
    if (this.state.allItemsInTheSearchSetAreSelected) {
      return `Apply the payment to all currently selected (${this.state.numberOfElementsInTheTable}) Client Invoices?`;
    }
    const idList = this.state.itemList.filter((x) => x.Selected === true).map((x) => x.CiId);
    return `Apply the payment to the selected ${idList.length} Client Invoice(s)?`;
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtons()}
        <TabOfDataTable
          type={OutstandingInvoiceItem}
          serviceFunction={ClientInvoiceService.ListOutstanding}
          convertDBItemsFunction={ClientInvoiceService.ConvertOutstandingDBItems}
          searchItem={this.state.searchItem}
          orderBy='CiId'
          orderDirection='Desc'
          errorCode='OCIA109'
          changeOfItemListFunction={(itemList, numberOfElementsInTheTable) =>
            this.setState({ itemList, numberOfElementsInTheTable })
          }
          changeOfAllItemsAreSelectedFunction={(allItemsInTheSearchSetAreSelected) => {
            this.setState({ allItemsInTheSearchSetAreSelected });
          }}
        />
      </div>
    );
  }
}
